import { SelectFilter } from '@/components/Select/types';
import { useErrorHandler } from '@/hooks';
import { loadCitiesByNameService } from '@/services';

export const useCitiesFilter = (): SelectFilter => async (value: string) => {
  const errorHandler = useErrorHandler();

  try {
    return await loadCitiesByNameService(value?.trim() || '');
  } catch (error) {
    errorHandler(error);
  }
};
